import PropTypes from 'prop-types';
import Modal from '~/js/components/global/Modal';

const { Component } = React;

class ResortSpecialOffers extends Component {

  constructor(props) {
    super(props);

    this.state = {
      offerTitle: '',
      offerDetails: ''
    };

    this.getOffers = this.getOffers.bind(this);
  }

  getOffers() {

    const { offerList, cdnURL } =  this.props;
    const imageBaseUrl = cdnURL + '/specials/specials/promotions';
    // const imageRegex = /Fall 4 Beaches|Up to $355 Instant Credit|Book Online & Get $25 Credit|Save up to 65% Off Rack Rates|4th Of July Gift|1 Free Night|$100 Tour Credit/i;
    const imageRegex = /Fall 4 Beaches|Up to $355 Instant Credit|Book Online & Get $75 Credit|Save up to 65% Off Rack Rates|1 Free Night|$100 Tour Credit/i;

    const offers = offerList.map((offer, i) => {

      const { title = '', description = '', rawHtml = '' } = offer;
      const match = title.match(imageRegex);
      const imageName = match ? match[0].replace(/\s|\W|["$"]/g, '-').toLowerCase() : 'default';

      return (
        <div className="specials-block" key={title}>
          <img
            className="img-responsive sb-figure"
            src={`${ imageBaseUrl }/${ imageName }.jpg`}
            alt="Special's Offer"  />

          <div className="sb-content">
            <h2 className="sb-title">
              {title}
            </h2>
            <p className="sb-text">
              {this.getDescription(description)}
            </p>
            <a href="#rst-offer-details"
              className="sb-more js-magnific-popup"
              onClick={this.viewOfferDetails(title, rawHtml)}
            >
              View Offer Details <i className="icon icon-link-arrow-beaches" />
            </a>
          </div>
        </div>
      );
    });

    return offers;
  }

  getDescription(description) {
    const descriptionPreview = description.slice(0, 200);

    return description.length > 200 ? descriptionPreview + '...' : descriptionPreview;
  }

  viewOfferDetails(offerTitle, offerDetails) {
    return () => {
      this.setState({offerTitle, offerDetails});
    };
  }

  render() {
    const { offerTitle, offerDetails } = this.state;

    return (
      <div>
        <div>
          {this.getOffers()}
        </div>

        <Modal id="rst-offer-details" title={offerTitle} content={offerDetails} />
      </div>
    );
  }
}

export default ResortSpecialOffers;

ResortSpecialOffers.defaultProps = {
  offerList: [],
  cdnURL: '#',
};
ResortSpecialOffers.propTypes = {
  offerList: PropTypes.array,
  cdnURL: PropTypes.string,
};
